<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="Modal"
        title="Arquivos"
    >
        <Form
            :additionals="additionals"
            :uploads="uploads"
            :item="item"
            :solicitacao="model"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        additionals: null,
        formData: null,
        item: [],
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item, model, additionals) {

            this.additionals = additionals
            this.item = item
            this.model = model
            this.$refs.Modal.show()
        },
    },
    props: {
        uploads: { type: Array, required: true },
    },
}
</script>